export default __webpack_public_path__ + "static/media/healthcare2.024d8059.png";